// src/services/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // Storage'ı ekleyin

const firebaseConfig = {
  apiKey: "AIzaSyA0ZeQcbX5xIpjg0TtK6hLoeo6IYNFjDn0",
  authDomain: "zq-portfoy.firebaseapp.com",
  databaseURL: "https://zq-portfoy-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "zq-portfoy",
  storageBucket: "zq-portfoy.firebasestorage.app",
  messagingSenderId: "744478808534",
  appId: "1:744478808534:web:cadfd48d448635500fac77",
  measurementId: "G-Y1DJ0CFWEH"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // Storage nesnesini oluşturun

export { db, auth, storage }; // storage'ı da export edin

